import script from "./videoManage.vue?vue&type=script&setup=true&lang=js"
export * from "./videoManage.vue?vue&type=script&setup=true&lang=js"

import "./videoManage.vue?vue&type=style&index=0&id=404b69ae&scoped=true&lang=css"
import "./videoManage.vue?vue&type=style&index=1&id=404b69ae&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-404b69ae"]])

export default __exports__